import { render, staticRenderFns } from "./SpecialApprovedInvoicesIndex.vue?vue&type=template&id=4fc848aa&scoped=true&"
import script from "./SpecialApprovedInvoicesIndex.vue?vue&type=script&lang=js&"
export * from "./SpecialApprovedInvoicesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc848aa",
  null
  
)

export default component.exports